import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { Col, Container, Image, Row } from "react-bootstrap";
import BigLoader from "../../components/BigLoader";
import AllHeader from "../../components/AllHeader";
import Parent from "../../container/Parent";
import axiosInstance from "../../api/axiosInstance";

function MoshahedeName() {
  const [load, setLoad] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const { id } = useParams();
  const UserID = localStorage.getItem("UserId");


  useEffect(() => {
    if (UserID !== null) {
      setLoad(true);
      axiosInstance
        .post("GetMade100Report", {
          itemId: id,
        })
        .then((res) => {
          setLoad(false);
          if (res.data.result === "true") {
            setViewImage(res.data.image);
            console.log("imageeee", res.data.image);
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  }, []);

  return (
    <div className="py-5">
      <AllHeader>
        <span>ابلاغیه الکترونیکی</span>
      </AllHeader>
      <Parent>
        <Row className="justify-content-center">
          <Col xs={12} md={8}>
            <Image src={viewImage} alt="" className="image-style" />
          </Col>
        </Row>

      </Parent>
      <BigLoader loading={load} />
    </div>
  );
}

export default MoshahedeName;
